"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BancoDoBrasilCheckNumberCalculator = /** @class */ (function () {
    function BancoDoBrasilCheckNumberCalculator() {
    }
    // Account validation
    BancoDoBrasilCheckNumberCalculator.calculateAccount = function (accountNumber) {
        var numbers = accountNumber.split("");
        var sumSeq = 0;
        var sequence = 0;
        for (var i = 0; i < numbers.length; i++) {
            var seq = 9 - i;
            sumSeq += parseInt(numbers[i]) * seq;
        }
        return this.module(sumSeq);
    };
    // Agency validation
    BancoDoBrasilCheckNumberCalculator.calculateAgency = function (agencyNumber) {
        var numbers = agencyNumber.split("");
        var sumSeq = 0;
        var sequence = 0;
        for (var i = 0; i < numbers.length; i++) {
            var seq = 5 - i;
            sumSeq += parseInt(numbers[i]) * seq;
        }
        return this.module(sumSeq);
    };
    BancoDoBrasilCheckNumberCalculator.module = function (sumSeq) {
        var result = 11 - (sumSeq % 11);
        if (result === 10) {
            return "X";
        }
        else {
            if (result === 11) {
                return "0";
            }
            else {
                return result.toString();
            }
        }
    };
    return BancoDoBrasilCheckNumberCalculator;
}());
exports.default = BancoDoBrasilCheckNumberCalculator;
//# sourceMappingURL=BancoDoBrasilCheckNumberCalculator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/br-bank-account-validator/dist/Validators/CheckNumber/BancoDoBrasilCheckNumberCalculator.js
// module id = 881
// module chunks = 1